import { useEffect } from "react";
import {
  DatePickerElement,
  DatePickerElementProps,
  FieldValues,
  useFormContext,
  useFormState,
} from "react-hook-form-mui";
import { isValid, parse } from "date-fns";

interface CustomDatePickerProps
  extends DatePickerElementProps<FieldValues, Date, Date> {
  displayPattern?: string;
}

export default function CustomDatePicker(props: CustomDatePickerProps) {
  const { displayPattern = "dd/MM/yyyy", name, ...datePickerProps } = props;

  const formContext = useFormContext();
  const { defaultValues } = useFormState();

  useEffect(() => {
    if (!name) return;

    const currentValue = formContext.watch(name);
    if (currentValue) {
      if (typeof currentValue === "string") {
        const parsedDate = parse(currentValue, displayPattern, new Date());
        if (isValid(parsedDate)) {
          formContext.setValue(name, parsedDate, { shouldValidate: true });
        }
      }
    } else {
      formContext.setValue(name, undefined);
    }
  }, [defaultValues]);

  return (
    <DatePickerElement
      {...datePickerProps}
      name={name}
      format={datePickerProps?.format || displayPattern}
      slotProps={{
        ...datePickerProps.slotProps,
        field: {
          ...datePickerProps.slotProps?.field,
          clearable: true,
          onClear: () => formContext.setValue(name, undefined),
        },
      }}
    />
  );
}
